import { Component, Inject, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { ThemeManagerService } from '~/services/theme-manager';
import { LayoutManagerService, PORTAL_DATA } from '~/shared/components/layout/layout-manager';

@Component({
    selector: 'app-stocks-quantity-per-account',
    templateUrl: './quantity-per-account.html',
    styleUrls: ['./quantity-per-account.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class StocksQuantityPerAccountComponent {
  _isNew: boolean;
  _active: boolean;
  _theme: string;
  _tooltipVisibilityForm: boolean = true;
  _isSingleDonutPopup: boolean =false;
  _isPageCategory: boolean =false;
  _isPageVendors: boolean =false;
  _isPageAddresses: boolean =false;
  _isPageLocation: boolean =false;
  _isPageLocationType: boolean =false;
  _isPageUsers: boolean =false;
  DashboardAccountInformation: Array<any>;
  _donutChartLarge: Array<any>;

  constructor(
    private _themeManager: ThemeManagerService,
    private _layoutManager: LayoutManagerService,
    @Inject(PORTAL_DATA) public data: any
  ) {
    if (data) {
      this._active = true;
      this._donutChartLarge = data.model.donutChartLarge;
      this._isSingleDonutPopup = data.model.isSingleDonutPopup;
      this._isPageCategory = data.model.isPageCategory;
      this._isPageVendors = data.model.isPageVendors;
      this._isPageAddresses = data.model.isPageAddresses;
      this._isPageLocation = data.model.isPageLocation;
      this._isPageLocationType = data.model.isPageLocationType;
      this._isPageUsers = data.model.isPageUsers;
    }
    this._themeManager.themeChange.subscribe((data) => {
      this._theme = data;
    });
    this._layoutManager.applyOverly();
  }
  _closeForm() {
    this._active = false;
    this.ngOnDestroy();
  }
  ngOnDestroy() {
    this._layoutManager.removeOverlay();
  }
  _onStateChanges(e: any) {
    if (e === 'minimized') {
      this._layoutManager.removeOverlay();
    } else {
      this._layoutManager.applyOverly();
    }
  }
}